import testService from 'ApiService/Student/testServices';
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { BallTriangle } from 'react-loader-spinner';

const MockTests = () => {
  const [mockTests, setMockTests] = useState([]);
  const { state } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const fetchMockTests = async () => {
    try {
      setLoading(true);
      const response = await testService.getMockTests();

      if (response.data.success) {
        setMockTests(response.data.data);
        toast.success('Mock tests loaded successfully');
      } else {
        toast.error('No mock tests found.');
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || 'Failed to fetch mock tests.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMockTests();
  }, []);

  if (loading) {
    return (
      <div className="flex h-40 items-center justify-center">
        <BallTriangle color="#5431ed" />
      </div>
    );
  }

  if (mockTests.length === 0) {
    return (
      <div className="flex h-40 items-center justify-center text-gray-500">
        No mock tests available.
      </div>
    );
  }

  return (
    <div className="mt-20 space-y-4 md:mt-10">
      {mockTests.map((test) => (
        <div
          key={test._id}
          className="overflow-hidden rounded-lg border border-gray-200 bg-white p-4 shadow-sm dark:bg-navy-800"
        >
          <div className="flex justify-between">
            <div>
              <h2 className="text-lg font-semibold text-gray-800 dark:text-white">
                {test.subjectName}
              </h2>
              <p className="text-sm text-gray-600">
                Date: {new Date(test.testDate).toLocaleDateString()} | Time:{' '}
                {test.testTime}
              </p>
              <a
                href={test.testLink}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-600 hover:underline"
              >
                Start Test
              </a>
            </div>
            <span className="text-xs text-gray-500">Status: {test.status}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MockTests;
